var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center fill-height"},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"20","width":"3"}}),_c('h2',{staticClass:"pl-4 mt-2"},[_vm._v(_vm._s(_vm.$t("please_wait"))+"...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }